import FAPictureCardActions from './FAPictureCardActions'
export default FAPictureCardActions
